export const OmniboxTelemetryEventSource = 'omni';


// Icons
export const SearchBoxIconSize = 20;

export const QuerySuggestionIconSize = 20;

export const QuickLinksIconSize = 20;

export const ContentSuggestionIconSize = 24;
export const ContentSuggestionExtraIconSize = 14;

// If the iconSize has to be modified here, make sure to update the size in the processRegistry() function located in the BeaconComponentRegistryFunctions.ts file within the vizportalclient repository.
export const CommandSuggestionIconSize = 24;

export const JumpBackInIconSize = 24;